<template>
    <div class="p-8 lg:px-16 lg:py-24 min-h-svh md:min-h-[50svh] bg-ivory">
        <div class="container mx-auto">
            <div class="grid lg:grid-cols-4 gap-8 lg:gap-6">
                <MonthNav v-model="month" :options="monthRange" v-show="!hasNoResults && showMonthNav" />

                <div class="lg:col-span-3" :class="{ 'lg:col-span-4!': !showMonthNav }">
                    <Transition name="fade" mode="out-in">
                        <Grid :items="items" />
                    </Transition>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { storeToRefs } from "pinia";
import { useFeedStore } from "@facet/utils/store.js";
import Grid from "@facet/components/Grid.vue";
import MonthNav from "@facet/global/MonthNav.vue";

const store = useFeedStore();
const { items, month, monthRange, showMonthNav, hasNoResults } = storeToRefs(store);
</script>
